import React from 'react';
import * as PropTypes from 'prop-types';
import './styles.scss';

ErrorPageFullScreen.propTypes = {
  onReloadBtnClick: PropTypes.func,
  errorTips: PropTypes.string,
  reloadBtnText: PropTypes.string
};

ErrorPageFullScreen.defaultProps = {
  errorTips: '加载失败，请点击重试',
  reloadBtnText: '重试'
};

export default function ErrorPageFullScreen(props) {
  const {
    onReloadBtnClick, errorTips, reloadBtnText
  } = props;
  return (

    <div className="fullscreen-error-page">
      <div className="error-icon" />
      <h5>{errorTips}</h5>
      {
        !!onReloadBtnClick && (
          <button
            type="button"
            onClick={() => {
              onReloadBtnClick();
            }}
          >
            {reloadBtnText}
          </button>
        )
      }
    </div>
  );
}
